// extracted by mini-css-extract-plugin
module.exports = {"User":"user_User__16Pew"};